import {ModalComponents} from 'constants/Modals';

import {useCallback} from 'react';

import TableRowActions from 'features/beersManager/shared/TableRowActions/TableRowActions';
import TableRowAvatar from 'features/beersManager/shared/TableRowAvatar/TableRowAvatar';
import TableRowWrapper from 'features/beersManager/shared/TableRowWrapper/TableRowWrapper';
import {setCheckedBeerAC} from 'features/beersManager/slice';
import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {setModalAC} from 'store/modal/modalSlice';
import {Beer} from 'typescript/models/Beer';
import './AddBeersRow.scss';

interface IProps {
  beer: Beer;
}

const AddBeersRow = ({beer}: IProps) => {
  const {
    id,
    attributes: {name, beer_logo, brewery_id},
  } = beer;
  const {pubBeers, beersBreweriesIncluded} = useGlobalState((state) => state.beersManager);
  const dispatch = useSetGlobalState();

  const isOnTap = pubBeers.some(({attributes: {beer_id}}) => beer_id === +id);

  const handleCheck = () => {
    dispatch(setCheckedBeerAC({id: +id, name, imageUrl: beer_logo || ''}));
    dispatch(setModalAC(ModalComponents.CHECKED_BEER_INFO));
  };

  const getBreweryName = useCallback(() => {
    const brewery = beersBreweriesIncluded.find((brewery) => +brewery.id === brewery_id);

    return brewery?.attributes.name || '';
  }, [beersBreweriesIncluded, brewery_id]);

  return (
    <TableRowWrapper className="add-beers-row" disabled={isOnTap} data-testid="add-beers-row">
      <td colSpan={2}>
        <div className="add-beers-row__avatar">
          <TableRowAvatar name={name} logo={beer_logo} breweryName={getBreweryName()} />
        </div>
      </td>
      <td>
        <TableRowActions checked={isOnTap} onCheck={handleCheck} infoDisabled />
      </td>
    </TableRowWrapper>
  );
};

export default AddBeersRow;
